import { render, staticRenderFns } from "./DistList.vue?vue&type=template&id=7cf7272f&scoped=true&"
import script from "./DistList.vue?vue&type=script&lang=js&"
export * from "./DistList.vue?vue&type=script&lang=js&"
import style0 from "./DistList.vue?vue&type=style&index=0&id=7cf7272f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf7272f",
  null
  
)

export default component.exports